(function () {
  /** @type {Function} */
  const main = () => {
    /** @type {Object} */
    window.videoBanner = window.videoBanner || {};
    if (window.videoBanner.initialized) {
      return;
    }
    window.videoBanner.initialized = true;
    document.addEventListener("DOMContentLoaded", () => {
      /** @type {HTMLDivElement[]}  */
      const videoBannerSections = Array.from(
        document.querySelectorAll("div.video-banner-section")
      );
      videoBannerSections.forEach((videoBannerSection) => {
        /** @type {HTMLVideoElement} */
        const videoBannerVideo = videoBannerSection.querySelector(
          "video.video-banner-video"
        );
        if (!videoBannerVideo) return;
        videoBannerSection.addEventListener("click", () => {
          try {
            if (videoBannerVideo.paused) videoBannerVideo.play();
          } catch (err) {
            return;
          }
        });
      });
    });
  };

  main();
})();
